import React from 'react';

import TextField from 'material-ui/TextField';
import Button from 'material-ui/Button';

import Console from '../../../lib/debug';

export default class SupersetCreate extends React.PureComponent {
    state = {
        title: this.props.block.title
    };

    handleChange = (key, e) => {
        let value = e.currentTarget.value;
        this.setState(() => ({
            [key]: value
        }));
    };

    handleClose = () => {
        this.props.onClose();
    };

    handleSave = () => {
        this.props.onSave(this.state.title);
    };

    render() {
        Console.render('designer.SupersetCreate');

        return (
            <div className="create-dialog superset-dialog layout-column">
                <div className="dialog-body">
                    <TextField
                        id="title"
                        label="Title"
                        autoFocus
                        fullWidth
                        value={this.state.title}
                        onChange={ev => this.handleChange('title', ev)}
                        margin="normal"
                    />
                </div>
                <div className="dialog-footer">
                    <Button onClick={this.handleClose}>Cancel</Button>
                    <Button
                        color="primary"
                        disabled={this.state.title === ''}
                        onClick={this.handleSave}
                    >
                        Save
                    </Button>
                </div>
            </div>
        );
    }
}
